import { render, staticRenderFns } from "./InformCenter.vue?vue&type=template&id=35cab8dc&scoped=true"
import script from "./InformCenter.vue?vue&type=script&lang=js"
export * from "./InformCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cab8dc",
  null
  
)

export default component.exports